import { getConvertedCurrency_api } from "api/campaignApi"
import { DEFAULT_CURRENCY } from "modules/Const"
import { CurrencyCodesType } from "modules/Types"

export const getCampaignTitleByCampaignType = (campaignType: 'views' | 'engagement' | 'default') => {
  switch(campaignType) {
    case "views":
      return "Cheapest Views"
    case "engagement":
      return "More Engagement"
    default:
      return "Recommended"
  }
}

export const getGeographiesTitleByGeographyType = (geographyType: 'global' | 'english' | 'custom') => {
  switch(geographyType) {
    case "global":
      return "Global Markets"
    case "english":
      return "English-speaking Markets"
    default:
      return "Custom"
  }
}

export const minimumDailyBudgetCalculator = async (targetingType: string, currency: CurrencyCodesType) => {
  const isDefatulCurrency = currency === DEFAULT_CURRENCY
  if(targetingType === "engagement") {
    return isDefatulCurrency ? 20 : await getConvertedCurrency_api({ from: DEFAULT_CURRENCY, to: currency, amount: 20 })
  } else {
    return isDefatulCurrency ? 10 : await getConvertedCurrency_api({ from: DEFAULT_CURRENCY, to: currency, amount: 10 })
  }
}
